import styled from "styled-components";
export const InputWrapper = styled.div `
  position: relative;
  height: 100%;
  ${({ withIcon }) => withIcon ? "width: calc(100% - 2.5rem)" : "width: 100%"};
  ${({ withIcon }) => (withIcon ? "margin-left: 2.5rem" : "")};
  @media ${({ theme }) => theme.device.touch} {
    ${({ withIcon }) => (withIcon ? "width: calc(100% - 2.75rem)" : "")};
    ${({ withIcon }) => (withIcon ? "margin-left: 2.75rem" : "")};
  }

  & > input {
    -webkit-appearance: none;
    ${({ hasReset }) => (hasReset ? `padding-right: 38px;` : "")}
  }

  & > input[type="date"] {
    ${({ hasReset }) => (hasReset ? `padding-right: 0.5rem;` : "")}
  }

  & > input,
  & > input + button {
    height: 2.5rem;

    @media ${({ theme }) => theme.device.touch} {
      height: 2.75rem;
    }
  }
`;
export const Input = styled.input `
  box-sizing: border-box;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  position: relative;
  font-family: ${({ theme }) => theme.fontTokens.defaultFont};
  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.white};
  text-align: ${({ textAlignment }) => textAlignment};
  padding: 0 0.5rem;
  border: 1px solid
    ${({ errors, name, theme, selected }) => {
    if (errors === null || errors === void 0 ? void 0 : errors[name])
        return theme.colors.error;
    if (selected)
        return theme.colors.black;
    return theme.colors.grey10;
}};
  height: 2.5rem;
  @media ${({ theme }) => theme.device.touch} {
    height: 2.75rem;
  }

  &::placeholder {
    color: rgba(${({ theme }) => theme.colors.transparent13}, 0.36);
  }

  &:read-only {
    background-color: ${({ theme }) => theme.colors.grey04};
    border: 1px solid rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
  }

  @media (hover: hover) {
    &:hover {
      ${({ theme, readOnly, errors, name }) => !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `background-color: ${theme.colors.offWhite};`
    : ""}
      ${({ theme, readOnly, errors, name, selected }) => !selected && !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `border: 1px solid ${theme.colors.grey14};`
    : ""}
    }
  }

  &:focus {
    ${({ theme, focused }) => focused ? `border: 1px solid ${theme.colors.primaryLight};` : ""};
    ${({ theme, focused }) => focused
    ? `outline: 1px solid ${theme.colors.primaryLight};`
    : "outline: none;"};
  }

  &:active {
    ${({ theme, readOnly, errors, name }) => !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `background-color: ${theme.colors.grey05};`
    : ""}
    ${({ theme, readOnly, errors, name }) => !readOnly && !(errors === null || errors === void 0 ? void 0 : errors[name])
    ? `border: 1px solid ${theme.colors.black};`
    : ""}
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.grey03};
    border: 1px solid rgba(${({ theme }) => theme.colors.transparentBlack}, 0);
    color: rgba(${({ theme }) => theme.colors.transparentBlack}, 0.26);
  }

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;

    &:focus {
      outline: none;
    }
  }

  &::-webkit-datetime-edit {
    font-family: ${({ theme }) => theme.fontTokens.defaultFont};
    font-size: ${({ theme }) => theme.fontTokens.font12[0]};
    color: ${({ theme, type, value }) => type === "date" && !value
    ? `rgba(${theme.colors.transparent13}, 0.36);`
    : theme.colors.black};
  }

  // remove arrows & clear button in input fields
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  // remove arrows in FF
  &[type="number"] {
    -moz-appearance: textfield;
  }
`;
